import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Droplet, Plus, Trash2 } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { API } from '@/utils/api';

const BASE = ['Huile moteur', 'Liquide de refroidissement', 'Lave-glace', 'Liquide de frein', 'Huile de boîte', 'Fluide de direction'];

const merge = (saved = []) => [
  ...BASE.map(name => saved.find(f => f.name === name) || { name, spec: '', qty: '' }),
  ...saved.filter(f => !BASE.includes(f.name)),
];

export const FluidsSection = ({ woId, wo, disabled }) => {
  const [rows, setRows] = useState(() => merge(wo.fluids));
  const [extra, setExtra] = useState('');
  const save = async (next) => {
    try { await axios.put(`${API}/work-orders/${woId}`, { fluids: next.filter(f => Number(f.qty) > 0 || f.spec || !BASE.includes(f.name)).map(f => ({ ...f, qty: Number(f.qty) || 0 })) }); }
    catch { toast.error('Erreur sauvegarde'); }
  };
  const set = (i, patch) => setRows(r => r.map((f, j) => (j === i ? { ...f, ...patch } : f)));
  const add = () => { if (!extra.trim()) return; const next = [...rows, { name: extra.trim(), spec: '', qty: '' }]; setRows(next); setExtra(''); save(next); };
  const remove = (i) => { const next = rows.filter((_, j) => j !== i); setRows(next); save(next); };
  return (
    <Card className="p-4 border-l-4 border-l-sky-500" data-testid="fluids-section">
      <div className="flex items-center gap-2 mb-1"><Droplet className="w-4 h-4 text-sky-600" /><h3 className="text-sm font-bold uppercase tracking-wide">Fluides mis dans le véhicule</h3></div>
      <p className="text-xs text-slate-500 mb-3">Quantité réellement mise (litres) — reprise dans le résumé « Véhicule prêt » et la facture.</p>
      <div className="space-y-2">
        {rows.map((f, i) => {
          const slug = f.name.replace(/\s+/g, '-').toLowerCase();
          return (
            <div key={f.name} className="grid grid-cols-[1fr_110px_90px_32px] gap-2 items-center" data-testid={`fluid-${slug}`}>
              <span className="text-sm font-medium">{f.name}</span>
              <Input className="h-9 text-sm" value={f.spec} disabled={disabled} onChange={e => set(i, { spec: e.target.value })} onBlur={() => save(rows)} placeholder="Type (5W30…)" data-testid={`fluid-spec-${slug}`} />
              <div className="relative"><Input type="number" inputMode="decimal" step="0.1" min="0" className="h-9 text-sm pr-6 font-mono" value={f.qty} disabled={disabled}
                onChange={e => set(i, { qty: e.target.value })} onBlur={() => save(rows)} placeholder="0" data-testid={`fluid-qty-${slug}`} />
                <span className="absolute right-2 top-2 text-xs text-slate-400">L</span></div>
              {!BASE.includes(f.name) ? <button type="button" onClick={() => remove(i)} className="text-slate-400 hover:text-red-600" data-testid={`fluid-remove-${slug}`}><Trash2 className="w-4 h-4" /></button> : <span />}
            </div>
          );
        })}
      </div>
      {!disabled && <div className="flex gap-2 mt-3">
        <Input value={extra} onChange={e => setExtra(e.target.value)} onKeyDown={e => e.key === 'Enter' && add()} placeholder="Autre fluide (ex : AdBlue)" className="h-9 text-sm" data-testid="fluid-extra-input" />
        <Button variant="outline" size="sm" className="h-9" onClick={add} data-testid="fluid-extra-add"><Plus className="w-4 h-4" /></Button>
      </div>}
    </Card>
  );
};
